import React from 'react';
import { Link } from 'react-router-dom';
import { contact, navigation } from '../data/site';
export function SiteFooter() {
  return <footer className="bg-ink text-paper" data-id="element-153" data-mp="3r8rherbwqbyw">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10" data-id="element-154" data-mp="3mhj5non3ueik">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-155" data-mp="3mfq2ijbpacfb">
          <div className="lg:col-span-6" data-id="element-156" data-mp="3hj7yxms3wk4k">
            <p className="font-display text-4xl leading-none" data-id="element-157" data-mp="3hi6c6l1qa970">DACB</p>
            <p className="mt-3 text-sm text-paper/60" data-id="element-158" data-mp="3dhw3v1qgr6oz">{contact.baseline}</p>
          </div>

          <nav aria-label="Navigation pied de page" className="lg:col-span-3" data-id="element-159" data-mp="38hi56aar593m">
            <p className="text-[11px] uppercase tracking-label text-paper/40" data-id="element-160" data-mp="33i5aj3dn2xqh">Navigation</p>
            <ul className="mt-4 space-y-2 text-sm" data-id="element-161" data-mp="2yjtzipblyh6o">
              <li data-id="element-162" data-mp="2yl558uom5z0f">
                <Link to="/" className="text-paper/80 transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-163" data-mp="2ylok22iyw7a8">
                  Accueil
                </Link>
              </li>
              {navigation.map(item => <li key={item.to} data-id="element-164" data-mp="15r4y6nidgqkw">
                  <Link to={item.to} className="text-paper/80 transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-165" data-mp="15q2b6qo678a9">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-166" data-mp="10rsf8dumg3nl">
            <p className="text-[11px] uppercase tracking-label text-paper/40" data-id="element-167" data-mp="10stpig3tcm49">Contact</p>
            <address className="mt-4 space-y-2 text-sm not-italic text-paper/80" data-id="element-168" data-mp="1oh37t81tirqn">
              <p data-id="element-169" data-mp="1tgzbt7aimj67">
                {contact.address}
                <br data-id="element-170" data-mp="1tfo6v45c35di" />
                {contact.city}
              </p>
              <p data-id="element-171" data-mp="1eqidhwt6g9dj">
                <a href={contact.phoneHref} className="transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-172" data-mp="1er0fla2ithtd">
                  {contact.phone}
                </a>
              </p>
              <p className="break-all" data-id="element-173" data-mp="27ffhqw0k05na">
                <a href={`mailto:${contact.email}`} className="transition-colors duration-150 ease-smooth hover:text-clay" data-id="element-174" data-mp="27ee3kio8r31c">
                  {contact.email}
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-paper/15 pt-6 text-[11px] uppercase tracking-label text-paper/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-175" data-mp="2h4w7nlnq3n41">
          <p data-id="element-176" data-mp="283o8z2haok9f">© {new Date().getFullYear()} SARL DACB</p>
          <Link to="/mentions-legales" className="transition-colors duration-150 ease-smooth hover:text-paper" data-id="element-177" data-mp="282v7oh13umyo">
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>;
}